import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ExactAlarmPermissionUseCase } from 'src/app/use-case/exact-alarm-permission/exact-alarm-permission.use-case';

@Component({
  selector: 'app-location-required',
  templateUrl: './request-exact-alarm.page.html',
  styleUrls: ['./request-exact-alarm.page.scss']
})
export class RequestExactAlarmModalPage {

  constructor(
    private modalCtrl: ModalController,
    private exactAlarmPermissionUseCase: ExactAlarmPermissionUseCase,
  ) {}

  onEnableClick() {
    const requestObs = this.exactAlarmPermissionUseCase.requestPermission();
    requestObs.subscribe((granted) => this.handlePermission(granted));
  }

  private async handlePermission(granted: boolean) {
    if (granted) {
      await this.modalCtrl.dismiss();
    }
  }
}
